<template>
    <div class="empty-state">
        <div class="empty-state_icon">
            <sw-icon :name="icon" />
        </div>
        <h5 class="empty-state_title">{{ title }}</h5>
        <p class="empty-state_description">{{ description }}</p>
        <div v-if="$slots.actions" class="empty-state_actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script setup>
    defineProps({
        icon: {
            type: String,
            default: 'folder'
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        }
    });
</script>

<style lang="scss" scoped>
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3em 2em;
    text-align: center;
    color: var(--textSecondary, #64748b);
}

.empty-state_icon {
    margin-bottom: 1em;

    .sw-icon {
        font-size: 3em;
        color: var(--borderColorLight, #e5e7eb);
    }
}

.empty-state_title {
    font-size: 1.125em;
    font-weight: 600;
    color: var(--textPrimary, #1e293b);
    margin: 0 0 0.5em 0;
}

.empty-state_description {
    font-size: 0.875em;
    line-height: 1.5;
    margin: 0 0 1.5em 0;
    max-width: 300px;
}

.empty-state_actions {
    display: flex;
    gap: 0.75em;
    flex-wrap: wrap;
    justify-content: center;
}

/* Responsividade */
@import '@/assets/css/mediaScreen.scss';

@include screen_medias(s, m) {
    .empty-state {
        padding: 2em 1.5em;
    }

    .empty-state_icon .sw-icon {
        font-size: 2.5em;
    }

    .empty-state_title {
        font-size: 1em;
    }

    .empty-state_description {
        font-size: 0.8125em;
        max-width: 250px;
    }
}
</style>